import validate from "/var/lib/jenkins/workspace/Vapor/agents_deploy_prod/agents/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}